// extracted by mini-css-extract-plugin
export default {"wrapper":"FranchisesTab_wrapper__tn6RL","headerSectionWrapper":"FranchisesTab_headerSectionWrapper__USjxD","title":"FranchisesTab_title__T2s+W"};